// extracted by mini-css-extract-plugin
export default {"labelBackground":"Background_labelBackground__tvK0X"};